import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { GoogleChartsModule } from 'angular-google-charts';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DxTemplateModule, DxButtonModule, DxDataGridModule, DxCheckBoxModule, DxSelectBoxModule, DxTreeListModule, DxFormModule, DxPopoverModule, DxPopupModule, DxLoadPanelModule, DxTextAreaComponent, DxTextAreaModule, DxTextBoxModule, DxDateBoxModule, DxValidatorModule, DxValidationGroupModule } from 'devextreme-angular';
import { MatDividerModule, MatInputModule, MatFormFieldModule, MatButtonModule, MatOptionModule, MatSelectModule, MatListModule, MatCheckboxModule, MatCardModule, MatProgressSpinnerModule, MatAutocompleteModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConsolaRoutingModule } from './consola-routing.module';
import { ConsolaComponent } from './consola.component';
import { TransmisionesComponent } from './components/transmisiones/transmisiones.component';
import { SinTransmitirComponent } from './components/sin-transmitir/sin-transmitir.component';
import { AlertadosComponent } from './components/alertados/alertados.component';
import { ImprimirPdfComponent } from './components/imprimir-pdf/imprimir-pdf.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClientesComponent } from './components/galeria/clientes/clientes.component';
import { GaleriaVehiculosComponent } from './components/galeria/galeria-vehiculos/galeria-vehiculos.component';
import { MapaModalComponent } from './components/transmisiones/mapa-modal/mapa-modal.component';
import { SafeUrlPipe } from './components/galeria/safe-url.pipe';
import { ReutilizablesModule } from '../reutilizables/reutilizables.module';
import { MaquetaComponent } from './components/maqueta/maqueta.component';
import { FotografiasComponent } from './components/fotografias/fotografias.component';
import { VerFotoComponent } from './components/fotografias/ver-foto/ver-foto.component';

@NgModule({
	declarations: [ConsolaComponent,
		TransmisionesComponent,
		SinTransmitirComponent,
		AlertadosComponent,
		ImprimirPdfComponent,
		ClientesComponent,
		GaleriaVehiculosComponent,
		MapaModalComponent,
		SafeUrlPipe,
		MaquetaComponent,
		FotografiasComponent,
		VerFotoComponent
	],
	imports: [
		CommonModule,
		ConsolaRoutingModule,
		MatDividerModule,
		DxTemplateModule,
		DxButtonModule,
		DxDataGridModule,
		DxCheckBoxModule,
		DxSelectBoxModule,
		DxTreeListModule,
		DxFormModule,
		DxPopoverModule,
		DxPopupModule,
		DxLoadPanelModule,
		DxTextAreaModule,
		DxTextBoxModule,
		DxDateBoxModule,
		DxValidatorModule,
		DxValidationGroupModule,
		FormsModule,
		MatInputModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatOptionModule,
		MatSelectModule,
		MatListModule,
		MatAutocompleteModule,
		MatSlideToggleModule,
		DragDropModule,
		GoogleChartsModule.forRoot(),
		NgxPermissionsModule,
		MatCheckboxModule,
		NgbModalModule,
		MatCardModule,
		MatDividerModule,
		MatProgressSpinnerModule,
		ReutilizablesModule

	],
	exports: [
		FormsModule,
		DragDropModule,
		ReactiveFormsModule
	],
	entryComponents: [
		ImprimirPdfComponent,
		MapaModalComponent,
		VerFotoComponent
	]
})
export class ConsolaModule { }
